module.exports = __webpack_public_path__ + "static/assets/36f4cd9e348d929a869de4f29ff0cd6d.png";